import React, {useState} from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton,} from '@mui/material';
import MindfileItemForm from './MindfileItemForm';
import CloseIcon from "@mui/icons-material/Close";
import { withStyles } from "@mui/styles";

const styles = {
  root: {
      margin: '16px',
      width: 'calc(100% - 32px)',
      maxHeight: 'calc(100% - 32px)'
  },
};

export const testValid = (v) => {
  for(let key in v)
    if(v[key])
      return false;
  return true;
}
export const getValid = (vf) => {
  return Object.fromEntries(Object.keys(vf).map(k => [k, vf[k]()]));
}
function ItemFormDialog(props) {
  const { mindfileUserLevel, item, id, itemType, handleItemChange, keywordsList, peopleList, folderList, addFolder, title, isOpen, handleSave, handleCancel, classes } = props;
  const isUpload = (itemType || item.item_data_type) === "Upload";
  const [validations, setValidations] = useState({
    name: false,
    description: false,
    date: false,
    emotion: false,
    beme: false,
  });

  const validateFields = {
    name: () => !item.name,
    description: () => !item.description && item.item_data_type !== "SurveyAttempt",
    date: () => !item.date,
    emotion: () => isUpload && !item.emotion,
    beme: () => isUpload && !item.beme,
  };

  const isValid =  testValid(validations);
  const curValid = testValid(getValid(validateFields))
  const validate = () => {
    const v = getValid(validateFields);
    setValidations(v);
    return testValid(v);
  };

  return (
      <Dialog PaperProps={{id:id, className:classes.root}} open={isOpen} fullWidth maxWidth="md">
        <DialogTitle style={{paddingBottom: 0}}>
          <div style={{display:'flex', flexWrap:'wrap-reverse', justifyContent:'space-between'}}>
            {title}
            <IconButton onClick={handleCancel} style={{width:'2rem', height:'2rem', margin:'-0.5rem 0 0 auto'}}>
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent style={{overflowY: 'visible'}}>
          <MindfileItemForm
            mindfileUserLevel={mindfileUserLevel}
            item={item}
            itemType={itemType || item.item_data_type}
            handleItemChange={handleItemChange}
            keywordsList={keywordsList}
            peopleList={peopleList}
            folderList={folderList}
            addFolder={addFolder}
            validations={validations}
            errors={(isValid || curValid) ? null : Object.keys(validations).filter(key => validateFields[key]())}
          />
        </DialogContent>
        <DialogActions style={{position:'sticky', bottom:0, backgroundColor: '#fffc', zIndex: 10}}>
          <Button id="itemEditSave" onClick={() => validate() && handleSave()} variant="contained" color="primary">
            Save
          </Button>
          <Button id="itemEditCancel" onClick={handleCancel} variant="contained" color="secondary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
  );
}

export default withStyles(styles)(ItemFormDialog);
